import * as z from 'zod';

import { dateTime } from '@/_shared';

/**
 * Form schema for creating/updating a Revenue Lockdown.
 * Dates use the project standard `YYYY-MM-DD` string format.
 */
export const revenueLockdownFormSchemaRaw = z.object({
  id: z.number(),
  name: z.string().nullable(),
  lock_start_date: z.string().refine((v) => !!v, { message: 'Lock start date is required' }),
  lock_end_date: z.string().refine((v) => !!v, { message: 'Lock end date is required' }),
});

export const revenueLockdownFormSchema = revenueLockdownFormSchemaRaw.refine(
  (v) => {
    if (!v.lock_start_date || !v.lock_end_date) return true;
    return (
      dateTime.parse(v.lock_start_date).startOf('day').valueOf() <=
      dateTime.parse(v.lock_end_date).startOf('day').valueOf()
    );
  },
  { path: ['lock_end_date'], message: 'Lock end date must be on or after lock start date' }
);

export type RevenueLockdownFormSchema = z.infer<typeof revenueLockdownFormSchema>;
